export const ymKey = 105420810; // yandex metric
